import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getCourses } from '../../../../api/TrainerAPI';
import './CourseViewer.css';

const CourseViewer = ({ trainerId }) => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [error, setError] = useState('');

    // Lazy load - only fetch when component mounts (tab selected)
    useEffect(() => {
        if (trainerId && !hasLoaded) {
            loadCourses();
        }
    }, [trainerId, hasLoaded]);

    const loadCourses = async () => {
        setIsLoading(true);
        setError('');
        try {
            const coursesData = await getCourses(trainerId);
            setCourses(coursesData || []);
            setHasLoaded(true);
        } catch (err) {
            setError('Failed to load courses');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const openCourse = (courseId) => {
        navigate(`/connect/course/${trainerId}/${courseId}`);
    };

    if (isLoading) {
        return (
            <div className="course-viewer">
                <div className="course-viewer__loading">
                    <div className="course-viewer__spinner"></div>
                    <p>Loading courses...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="course-viewer">
                <div className="course-viewer__error">
                    <p>{error}</p>
                    <button onClick={loadCourses}>Try Again</button>
                </div>
            </div>
        );
    }

    if (courses.length === 0) {
        return (
            <div className="course-viewer">
                <div className="course-viewer__empty">
                    <MenuBookIcon sx={{ fontSize: 48 }} />
                    <p>No courses created yet</p>
                </div>
            </div>
        );
    }

    return (
        <div className="course-viewer">
            <div className="course-viewer__list">
                {courses.map(course => (
                    <div key={course.id} className="course-viewer__course">
                        <button 
                            className="course-viewer__course-header"
                            onClick={() => openCourse(course.id)}
                        >
                            <div className="course-viewer__course-info">
                                <SchoolIcon sx={{ fontSize: 24 }} />
                                <div>
                                    <h3 className="course-viewer__course-title">{course.title}</h3>
                                    {course.description && (
                                        <p className="course-viewer__course-desc">{course.description}</p>
                                    )}
                                    {course.modules?.length > 0 && (
                                        <p className="course-viewer__course-meta">
                                            {course.modules.length} module{course.modules.length !== 1 ? 's' : ''}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <ChevronRightIcon sx={{ fontSize: 20 }} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CourseViewer;
